<template>
	<div>
		<el-form
			ref="form"
			:model="info"
			status-icon
			label-position="right"
			label-width="6rem"
			size="mini"
			v-loading="loadings.main"
			@submit.native.prevent
			class="row"
			:rules="rules"
			v-if="hasGetTableDataModel"
		>
			<div class="col-md-4">
				<div class="form-group" v-loading="loadings.customer">
					<div class="form-group-title">客户信息</div>
					<div class="row">
						<div class="col-md-12">
							
							<div class="operator">
								<div class="operator-col">
									<customer-input
										size="mini"
										ref="customerInput"
										v-model="customerInfo"
										:params="{type:'user',allowCreate:true}"
									></customer-input>
								</div>
								<div class="operator-col">
									<el-button
										size="mini"
										type="primary"
										@click="handleCharge()"
										v-if="customerInfo._id"
										>充值
									</el-button>
								</div>
								<div class="operator-col">
									<router-link
										:to="{name:'Customer-User-Show',params:{id:customerInfo._id}}"
										target="_blank"
										v-if="customerInfo._id"
									>
										<el-button
											size="mini"
											type="success"
											>详情
										</el-button>
									</router-link>
								</div>
							</div>
						</div>
						<div class="col-md-12 mt-3">
							<table class="table" >
									<tr>
										<th>姓名</th><td>{{customerInfo.name}}</td>
										<th>电话</th><td>{{customerInfo.phone}}</td>
									</tr>
									<tr>
										<th>类型</th><td>{{customerInfo.type.name}}</td>
										<th>VIP等级</th><td>{{customerInfo.agent_level.name}}</td>
									</tr>
									<tr>
										<th>积分余额</th><td>{{customerInfo.credits}}</td>
										<th>账户余额</th><td>{{customerInfo.balance}}</td>
									</tr>
									<tr>
										<th>全局积分速率</th><td>{{configs['Product.credit_ratio']}}</td>
										<th>积分兑换比率</th><td>{{configs['Product.credit_use_ratio']}}</td>
									</tr>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<div class="form-group-title">订单信息</div>
					<div class="row">
						<div :class="'col-md-'+(key.col?key.col:6)" v-for="(key,index) in orderFields" :key="index">
							<span v-if="key.name=='null'"></span>

							<el-form-item :label="dataModels['Order'][key.name].show_name" :prop="key.name" v-else>
								<field-editor
									v-model="info[key.name]"
									:field-info="dataModels['Order'][key.name]"
									:width="key.width"
									:params="key.params ? key.params :{}"
									@change="handleOrderEdited(key)"
								></field-editor>
							</el-form-item>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<div class="form-group-title">付款信息</div>
					<div class="row">
						<div class="col-md-6">
							<el-form-item label="总数量" >
								<span>{{total_amount}}</span>
							</el-form-item>
						</div>
						<div class="col-md-6">
							<el-form-item label="总价格" >
								<span>{{$root.currencyCode}} {{total_price}}</span>
							</el-form-item>
						</div>
						<div :class="'col-md-'+(key.col?key.col:6)" v-for="(key,index) in payFields" :key="index">
							<span v-if="key.name=='null'"></span>
							<el-form-item :label="dataModels['Order'][key.name].show_name" :prop="key.name" v-else>
								<field-editor
									v-model="info[key.name]"
									:field-info="dataModels['Order'][key.name]"
									:width="key.width"
									:params="key.params ? key.params :{}"
									@change="handleOrderEdited(key)"
								></field-editor>
							</el-form-item>
						</div>
					</div>
					<div>
						<table class="table table-striped">
							<tr v-for="(payInfo,index) in payMethodsInfo" :key="index">
								<td>{{payInfo.pay_method.name}}</td>
								<td>
									<span v-if="payInfo.pay_method.index!=60">{{$root.currencyCode}} {{payInfo.total_price}}</span>
									<span v-else>{{configs['Product.credit_use_ratio'] * payInfo.total_price}} / {{configs['Product.credit_use_ratio']}} = {{$root.currencyCode}} {{payInfo.total_price}}</span>
								</td>
								<td> <el-button size="mini" @click="doRemovePayMethod(index)">x</el-button> </td>
							</tr>
							<tr >
								<td>总计</td>
								<td>{{totalPayPrice}}</td>
								<td> </td>
							</tr>
						</table>
						<el-button size="mini" type="primary" :disabled="canNotAddPayment" @click="handleShowAddPay('misc')">添加支付方式</el-button>
						<el-button size="mini" type="primary" :disabled="canNotAddPayment" @click="handleShowAddPay('balance')" class="ml-3">使用余额</el-button>
						<el-button size="mini" type="primary" :disabled="canNotAddPayment" @click="handleShowAddPay('credits')" class="ml-3">使用积分</el-button>
					</div>
				</div>
			</div>
		</el-form>
		<order-items v-if="hasGetTableDataModel" v-model="info.items"></order-items>
		
		<items
			class="mt-3"
			@insert="onInsertItems($event)"
			:customer-id="customerInfo._id"
			:warehouse-id="info.warehouse._id"
			v-if="hasGetTableDataModel"
			:is-need-cost="true"
			:is-check-less-than-holder="isCheckLessThanHolder"
			:agent-level="customerInfo.agent_level"
			:is-use-price="true"
			:is-pre-sale="info.type.index==40"
		></items>
		<hr />
		<div class="btn-holder text-center" v-loading="loadings.main">
			<el-button size type="success" :disabled="info.items.length==0 || customerInfo._id=='' || info.warehouse._id==''" @click="handleCreate">保存</el-button>
		</div>
		<charge-editor :show.sync="sendChargeVisible" :user-info="customerInfo" :record-id="customerInfo._id"  @change="onChargeChange"></charge-editor>
		<pay-method-editor
			:show.sync="payEditorVisible"
			v-if="payEditorVisible"
			:used-pay-method="payMethods"
			:total-pay="total_price-totalPayPrice"
			@submit="onAddPayMethod"
		></pay-method-editor>
		<customer-pay-editor
			:show.sync="customerPayVisible"
			v-if="customerPayVisible"
			:customer-info="customerInfo"
			:pay-method="customerPayMethod"
			:total-pay="total_price-totalPayPrice"
			@submit="onAddPayMethod"
		></customer-pay-editor>
		<barcodescan shopName="GZ1" @handle="handleBarcode"></barcodescan>
	</div>
</template>

<script>
import Order from "@/mixinsApp/Order.js";
import TxOp from "@/mixinsApp/TxOp.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import ChargeEditor from "@/views/Customer/widgets/ChargeEditor.vue";
import PayMethodEditor from "@/views/Order/widgets/PayMethodEditor.vue";
import CustomerPayEditor from "@/views/Order/widgets/CustomerPayEditor.vue";
import Barcodescan from '@/components/Barcodescan'

export default {
	mixins: [Order, TxOp],
	components: {ChargeEditor,PayMethodEditor,CustomerPayEditor,Barcodescan},
	config: {
		adminFilter: [
			{
				k: "is_leave",
				t: "bool",
				v: 0,
			},
			{
				k: "is_saler",
				t: "bool",
				v: 1,
			},
		],
		
	},
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				insert: false,
				customer: false,
			},
			customerInfo: {
				phone:"",
				name:"",
				agent_level:{
					name:"",
					value:""
				},
				type:{
					name:"",
					value:""
				},
				balance:0,
				credits:0,
				_id:""
			},
			info: {
				customer: {
					_id: "",
					agent_level:{
						name:"",
						value:""
					}
				},
				warehouse: {
					_id: "",
				},
				express_type: {
					index: 0,
				},
				address: {
					_id: "",
					name: "",
					street: "",
					phone: "",
					nation: {
						index: "852",
						name: "香港",
					},
				},
				send_from_type: {
					index: 0,
				},
				pay_method: {
					index: 1,
				},
				has_payed: false,
				express_fee: 0,
				discount: 0,
				desc: "",
				items: [],
				type: {
					index: 0,
					name: "订单",
				},
			},
			scannerInput:"",
			addressField: {
				name: "address",
				params: {
					needFilter: true,
					kvFilter: [],
					allowCreate: false,
					isFreeMode: true,
				},
				nameFields: ["province", "address"],
				width: "100%",
				col: 6,
			},
			payFields:[
				{
					name: "discount",
					width: "100%",
					col: 12,
				}
			],
			payMethodsInfo:[],
			defaultValue: {
				customer: {
					name: "",
					_id: "",
					agent_level: 0,
					type: 1,
				},
				address: {
					_id: "",
					name: "",
					street: "",
					phone: "",
				},
			},
			sendChargeVisible:false,
			payEditorVisible:false,
			customerPayVisible:false,
			customerPayMethod:"",
			rules: {
			customer: [
				{
					required: true,
					message: "请输入",
					trigger: "change",
					type: "object",
					fields: {
						name: { type: "string", required: true, message: "请选择" },
						_id: { type: "string", required: true, message: "请选择" }
					}
				}
			],
			warehouse: [
				{
					required: true,
					message: "请输入",
					trigger: "change",
					type: "object",
					fields: {
						name: { type: "string", required: true, message: "请选择" },
						_id: { type: "string", required: true, message: "请选择" }
					}
				}
			],
			pay_method: [
				{
					required: true,
					message: "请输入"
				}
			]
		},
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping","configs"]),
		isCheckLessThanHolder() {
			// return true;
			if (this.userPrivilegeMapping[42]) {
				return false;
			} else {
				return true;
			}
		},
		canNotAddPayment() {
			if (this.total_price <= 0) {
				return true;
			}
			if (this.totalPayPrice >= this.total_price) {
				return true;
			}


			return false;
		},
		fields() {
			return this.userFields.concat(this.orderFields).concat(this.payFields);
		},
		payMethods() {
			const payMethods = this.payMethodsInfo.map(payMethod => {
				return payMethod.pay_method.index;				
			});
			return payMethods;
		},
		totalPayPrice() {
			let totalPayPrice = 0;
			this.payMethodsInfo.forEach(payMethod => {
				totalPayPrice += payMethod.total_price;
			})
			return totalPayPrice;
		},
		userFields() {
			const fields = {
				customer: {
					name: "customer",
					params: {
						type: "Agent",
						tipShow: "balance",
						tipShowName: "当前余额",
						allowCreate: true,
					},
					width: "100%",
				},
				express_type: {
					name: "express_type",
					params: {
						isRadio: true,
					},
				},
				send_from_type: {
					name: "send_from_type",
					width: "100%",
				},
				warehouse: {
					name: "warehouse",
				},
				has_help_clearance: {
					name: "has_help_clearance",
				},
			};
			// if (this.customerInfo._id) {
			// 	this.addressField.params.kvFilter = [
			// 		{ k: "customer", t: "_id", v: this.customerInfo._id },
			// 	];
			// }
			//10 => '代发货',
			// 20 => '自取',
			if (this.info.express_type.index == 10) {
				delete fields.warehouse;
				// this.addressField.params.isFreeMode = true;
			} else if (this.info.express_type.index == 20) {
				// delete fields.address;
				delete fields.send_from_type;
			} else {
				delete fields.warehouse;
				// fields.address.params.isFreeMode = false;

				// delete fields.receiver;
				// delete fields.receiver_phone;
				// delete fields.receiver_street;
			}
			return Object.values(fields);
		},
		orderFields() {
			const fields = {
				// saler: {
				// 	name: "saler",
				// 	params: {
				// 		allowCreate: false,
				// 		notUseMeAsDefault: true,
				// 		kvFilter: this.adminFilter,
				// 	},
				// },
				warehouse: {
					name: "warehouse",
					params: {
						allowCreate: false,
					},
				},
				desc: {
					name: "desc",
					width: "100%",
					col: 12,
				},
				primary_img: {
					name: "primary_img",
					width: "100%",
					params: {
						// isFlat: true
					},
					col: 12,
				},
				
			};
			return Object.values(fields);
		},
		
	},

	props: {
		recordId: {
			type: String,
			default: "",
		},
		value: {
			type: Object,
			default: null,
		},
	},
	created() {
		this.getConfigs(true);
	},
	mounted() {
		this.$refs.scannerInput.focus();
	},
	methods: {
		...mapMutations(["getConfigs"]),
		handleBarcode(barcodeMap) {
			if (barcodeMap.type == 'product') {
				this.scannerInput = barcodeMap.code;
				this.handlerScannerPD();
			} else {
				console.log(barcodeMap);
			}
	    },
		handlerScannerPD(event) {
			console.log(this.scannerInput);
			const itemId = this.scannerInput.substr(2,this.scannerInput.length-2);
			if (this.itemsDuplicateCheck[itemId]) {
				this.$message.error("录入数据有重复，请检查！");
				this.scannerInput = '';
				return;
			}
			
			this.$axios
				.get(`/orderm/get_item_info/${itemId}`)
				.then(json => {
					const item = {
						_id: itemId,
						brand: json.data.info.brand,
						classify: json.data.info.classify,
						color: json.data.info.color,
						model: json.data.info.model,
						brand_show_id: json.data.info.brand_show_id,
						product_color: json.data.info.product_color,
						item: {
							_id:itemId
						},

						amount: 1,
						price_per: json.data.info.price_1,
						total_price: json.data.info.price_1,
						
					};
					this.info.items.push(item);
					this.scannerInput = '';
				}).catch(e=>{
					this.scannerInput = '';
				})
				
			
		},
		handleOrderEdited(key) {},
		doResetAll() {
			// this.initInfo();
		},
		onChargeChange(data) {
			this.customerInfo = data.user;
		},
		doChange() {
			this.$refs['customerInput'].refreshData();
		},
		
		handleShowAddPay(method = '') {
			if (method=='' || method=='misc') {
				this.payEditorVisible = true;
			} else {
				this.customerPayMethod = method;
				this.customerPayVisible = true;
				
			}
		},
		doRemovePayMethod(index) {
			this.payMethodsInfo.splice(index, 1);
		},
		onAddPayMethod(val) {
			for (let k in this.payMethodsInfo) {
				if (this.payMethodsInfo[k].pay_method.index == val.pay_method.index) {
					this.$set(this.payMethodsInfo,k,val)
					return;
				}
			}
			this.payMethodsInfo.push(val);
		},
		handleCharge(){
			this.sendChargeVisible = true;
		},
		handleCreate() {
			this.$confirm("商品将直接出库，确认录入信息正确？", "提示", {
				type: "warning",
			}).then(() => {
				this.doCreate();
			});
		},
		doCreate() {
			this.loadings.main = true;
			let data = JSON.parse(JSON.stringify(this.info));
			data.customer = {
				_id: data.customer._id,
			};
			delete data.logs;
			data.items = data.items.map(val => {
				return {
					_id: val._id,
					item: val.item,
					amount: val.amount,
					price_per: val.price_per,
					total_price: val.total_price,
					product_color: {
						_id: val.product_color._id,
					},
				};
			});
			data.payMethods = this.payMethodsInfo;
			
			this.$axios
				.post(`/orderm/do_fast_create_order`, data)
				.then(json => {
					this.loadings.main = false;

					this.$message.success("成功");
					this.$router.push({
						name: "Order-Info",
						params: {
							id: json.data.info._id,
							tab: "info",
						},
					});
				})
				.catch(json => {
					this.loadings.main = false;
					this.$message.error(json.data.msg);
				});
		},
		getCustomerInfo(_id) {
			//说不要
			// if (this.info.express_type.index != 0) {
			// 	this.info.address.name = "";
			// 	this.info.address.street = "";
			// 	this.info.address.phone = "";
			// 	return;
			// }
			// this.loadings.customer = true;
			// this.$axios.get(`/curd/info/customer/${_id}`).then(json => {
			// 	this.loadings.customer = false;
			// 	this.info.address.name = json.data.info.name;
			// 	this.info.address.street = json.data.info.street;
			// 	this.info.address.phone = json.data.info.phone;
			// });
		},
	},
	watch: {
		customerInfo: {
			handler(val) {
				if (val) {
					this.info.customer = {
						_id:val._id,
						name:val.name,
						phone:val.phone,
					}
				}
			},
			immediate: true,
		},
		value: {
			handler(val) {
				if (val) {
					this.info = Object.assign({}, val);
				}
			},
			immediate: true,
		},
		"info.customer._id": {
			handler(_id) {
				if (_id) {
					this.getCustomerInfo(_id);
				}
			},
			immediate: true,
		},
		"info.express_type.index": {
			handler(val) {
				if (val == 0) {
					this.getCustomerInfo(this.info.customer._id);
				}
			},
		},
	},
};
</script>
<style>
.el-radio-button--mini .el-radio-button__inner {
	padding: 7px 7px;
}
</style>
